namespace RioERP.Web.Enums {
    export enum BarcodeType {
        Code128 = 1,
        Code11 = 2,
        Code2of5Interleaved = 3,
        Code39 = 4,
        Code39FullASCII = 5,
        Code93 = 6
    }
    Serenity.Decorators.registerEnumType(BarcodeType, 'RioERP.Web.Enums.BarcodeType');
}
